<!-- IconSendArtwork.vue - "Send Us Your Artwork" icon (clock/send) -->
<template>
  <svg 
    width="35" 
    height="35" 
    viewBox="0 0 30 28" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="icon-send-artwork"
  >
    <path 
      d="M18.0026 18.7048V13.2658H20.2529V17.4224L23.9134 19.5007L22.7883 21.4169L18.0026 18.7048ZM0 23.5837V14.7398L10.6665 12.1161C10.7866 11.9245 10.9216 11.7476 11.0566 11.556L0 8.84387V0L18.0476 7.47307C18.5277 7.36989 19.0077 7.36989 19.5028 7.36989C22.2932 7.36989 24.9636 8.46064 26.9289 10.3916C27.3039 10.76 27.649 11.158 27.949 11.5707L28.5041 11.7918L28.2041 11.9097C29.664 14.0361 30.2656 16.6203 29.8917 19.1588C29.5177 21.6972 28.195 24.0079 26.1815 25.6403C24.1679 27.2726 21.6077 28.1098 19.0001 27.9884C16.3925 27.8671 13.9243 26.796 12.0767 24.9839C10.6215 23.5837 9.63139 21.7264 9.21133 19.7661L0 23.5837ZM26.7789 17.6877C26.7789 13.7375 23.5084 10.5389 19.5028 10.5389C17.5675 10.5389 15.7523 11.2907 14.3571 12.632C12.9919 14.0028 12.2268 15.7863 12.2268 17.6877C12.2268 21.638 15.4822 24.8365 19.5028 24.8365C20.4629 24.8365 21.4081 24.6597 22.2932 24.3207C23.1633 23.9374 24.0035 23.4068 24.6486 22.7435C25.3236 22.1097 25.8637 21.2843 26.2538 20.4293C26.5988 19.5597 26.7789 18.6311 26.7789 17.6877Z" 
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSendArtwork'
};
</script>

<style scoped>
.icon-send-artwork {
  display: block;
}
</style>
